import { HttpClient } from '../HttpClient';
/**
 * * Get Launch Darkly Flags
 */
export const GetLaunchDarklyFlags = async () => {
  try {
    const { data } = await HttpClient.get(
      '/api/instawage/Flags/Me/LaunchDarkly'
    );
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
